import { BASE_API_URL } from "../../../../config/url"

export const VERIFY_OTP = 'OTP VERIFACATION DONE'
export const VERIFY_OTP_DONE = 'OTP VERIFACATION DONE'
export const RESEND_OTP="RESEND_OTP"

export const  OTP_VARIFY_URL = `${BASE_API_URL}/onboarding/user`